export default "__VITE_ASSET__4d2d39f0__"